import { render, staticRenderFns } from "./StandardModelViz.vue?vue&type=template&id=58148eca&scoped=true"
import script from "./StandardModelViz.vue?vue&type=script&lang=js"
export * from "./StandardModelViz.vue?vue&type=script&lang=js"
import style0 from "./StandardModelViz.vue?vue&type=style&index=0&id=58148eca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58148eca",
  null
  
)

export default component.exports